<article class="app-article-template" *transloco="let t" xmlns="http://www.w3.org/1999/html">

  <div class="" style="float: none">
    <span *ngIf="article.publicationDate">{{ article.publicationDate | date: DEFAULT_DATE_FORMAT }}</span>
    <span *ngIf="article.publicationDate && article.articleType" style="padding-left: 5px; padding-right: 5px;" > - </span>
    <span *ngIf="article.articleType">{{ t("article.type." + article.articleType) }}</span>
    <span *ngIf="article.articleType && article.pages && isPages()" style="padding-left: 5px; padding-right: 5px;" > - </span>
    <span *ngIf="isPages()">{{ t("section.issue.pageFromTo") }}: {{ article.pages }}</span>
  </div>

  <div class="title" *ngIf="article?.title">
    <a *ngIf="article.articleContentId" class="article-title-overflow" title="{{t('alternate.article-full-content') + ': ' + article.title}}"  attr.aria-label="{{t('alternate.article-full-content') + ': ' + article.title}}}}"
       routerLink="/article/{{article.articleId}}/{{article.currentLanguage}}">{{ article.title }}</a>
    <span *ngIf="!article.title" class="article-title-overflow">{{ article.title }}</span>
  </div>

  <div class="authors pt-1 mb-3 mt-0" *ngIf="article?.authors">
            <span *ngFor="let author of article?.authors;  let last = last;">
          {{ author.name }} {{ author.surname }}<span *ngIf="!last" style="margin-left: 1px; margin-right: 3px;">, </span>
        </span>
  </div>

  <div *ngIf="isViewFilesAndAbstract()">
    <span *ngIf="isHasFiles()" class="me-1" style="font-size: 20px" >
      <span *ngIf="hasFileAndFree()"><a target="_blank" title="{{t('alternate.link-download-article')}}"  attr.aria-label="{{t('alternate.link-download-article')}}" href="{{article.articleUrl}}"><i  class="bi bi-file-{{getFileType()}}-fill"></i></a></span>
      <i *ngIf="article.hasHtml" class="bi bi-filetype-html"></i>
    </span>
    <a *ngIf="article.anAbstract"  title="{{t('alternate.abstract-text')}}"  attr.aria-label="{{t('alternate.abstract-text')}}"  class="abstract-btn collapsed" data-bs-toggle="collapse" href="#collapse-abstract-{{article.articleId}}" role="button" aria-expanded="false" [attr.aria-controls]="'collapse-abstract-'+article.articleId">
      {{t('alternate.label-abstract')}}
    </a>
  </div>
  <div *ngIf="article.anAbstract" class="collapse" id="collapse-abstract-{{article.articleId}}">
    <blockquote class="blockquote">
      <p [innerHTML]="article.anAbstract"></p>
    </blockquote>
  </div>


  <div *ngIf="isPanelLangaugesViewsIdentifiers()" class="row {{getFontSizeClass()}}">
    <div class="col-lg-5" *ngIf="!isTemplate(PageType.HOME)">
      <!-- other versions -->
      <div *ngIf="article?.otherVersions">
        <div class="d-flex mt-1 text-languages">
          <div class="h-100 pe-1">{{ t("section.article.language-version") }}:</div>
          <div class="flex-shrink-1">
            <div *ngFor="let version of article?.otherVersions" style="margin-right: 20px;">
              <a  title="{{t('alternate.article-version')}}"  attr.aria-label="{{t('alternate.article-version')}}"   routerLink="/article/{{version.articleId}}/{{version.language}}">
                <span class="fi fi-{{convertToCountry(version.language)}} flag"></span>
                <span class="ms-1">{{ t(concat('language.', (version.language))) }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-{{isTemplate(PageType.HOME) ? '4':'2' }} ">
      <div class="mt-1  text-statistic">
        <span class="views pt-1 mt-1" *ngIf="article?.htmlViewsCount">
          <i  placement="top" ngbTooltip="{{t('msg.no-of-views')}}" class="bi bi-eye-fill"></i>
          <span>{{ article.htmlViewsCount }}</span>
        </span>

        <span class="downloaded pt-1 mt-1" *ngIf="article?.downloadeCount">
          <i  placement="top" ngbTooltip="{{t('msg.no-of-downloads')}}" class="bi bi-cloud-arrow-down-fill"></i>
          <span>{{ article.downloadeCount }}</span>
        </span>
      </div>
    </div>
    <div class="col-lg-{{isTemplate(PageType.HOME) ? '7':'5' }}">
      <div class="mt-1 text-identifiers">
        <div *ngIf="article?.doi">{{ t("section.article.doi") }}: <span class="value">{{ article.doi }}</span></div>
        <div *ngIf="article?.gicid && isGicid()">{{ t("section.article.gicid") }}: <span class="value">{{ article.gicid }}</span></div>
        <div *ngIf="article?.fullIssue">{{ t("section.article.issue") }}: <span class="value">{{ article.fullIssue }}</span></div>
      </div>
    </div>
  </div>
</article>


